import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// ✅ Axios instance
const axiosInstance = axios.create({
  baseURL: apiUrl + "api/",
});

// ✅ TOKEN HELPERS (ADD THIS)
export const getAccessToken = () => {
  return localStorage.getItem("accessToken");
};

export const setAccessToken = (token) => {
  localStorage.setItem("accessToken", token);
};

export const clearAccessToken = () => {
  localStorage.removeItem("accessToken");
};

// ✅ REQUEST INTERCEPTOR (token attach karega)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();

    // ❌ is route pe token mat bhejna
    const isPublicRoute = config.url.includes("bulk-enquiry");

    if (token && !isPublicRoute) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ RESPONSE INTERCEPTOR
axiosInstance.interceptors.response.use(
  (response) => {
    const { code, message, data } = response.data || {};

    return {
      code: code || 500,
      message: message || "Something went wrong! Try Again",
      data: data || null,
    };
  },
  (error) => {
    console.error("API Error:", error.response || error.message);

    // 🔥 OPTIONAL: auto logout on 401
    if (error?.response?.status === 401) {
      clearAccessToken();
      window.location.href = "/login"; // redirect
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;